/**
 * Project-less entries (issue #10) get a default blue chip so they read
 * visually as "task without project" rather than blank. The blue matches
 * the brand primary (the same color the "Add Task" button uses):
 * `hsl(217 91% 60%)` = #3B82F6 (Tailwind blue-500).
 */
export const NO_PROJECT_COLOR = '#3B82F6';
export const NO_PROJECT_NAME = 'No project';